import { useTranslation } from 'react-i18next';
import { SidebarRow } from '@widgets';
import { Text } from '@shared/widgets';

interface Props {
  label: string;
  currentAmount: number;
  limitAmount: number;
  currentNumber: number;
  limitNumber: number;
  symbol?: string;
}

export const LimitRow = (props: Props) => {
  const { t } = useTranslation('card');

  return (
    <div className='mb-5'>
      <Text>{props.label}</Text>
      <SidebarRow
        className='!mb-0 mt-2'
        leftRowText={t('sidebar.limits.fields.usedAmount')}
        rightRowText={props.symbol ? props.symbol + props.currentAmount + '/' + props.symbol + props.limitAmount : undefined}
      />
      <SidebarRow
        className='!mb-0 mt-2'
        leftRowText={t('sidebar.limits.fields.usedTxnNumber')}
        rightRowText={props.currentNumber + '/' + props.limitNumber}
      />
    </div>
  );
};
